import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { FaBell, FaCheck, FaTrash } from 'react-icons/fa';
import { API_BASE_URL, AUTH_TOKEN_KEY } from '../../utils/constants';
import LoadingSpinner from '../../components/common/LoadingSpinner';
import DashboardLayout from '../../components/layout/DashboardLayout';
import './NotificationScreen.css';

const NotificationScreen = () => {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchNotifications();
  }, []);

  const fetchNotifications = async () => {
    try {
      setLoading(true);
      const accessToken = localStorage.getItem(AUTH_TOKEN_KEY);
      
      if (!accessToken) {
        toast.error('Access token not found. Please log in again.');
        return;
      }

      const response = await fetch(`${API_BASE_URL}api/doctor/notifications`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
        },
      });

      if (response.ok) {
        const data = await response.json();
        setNotifications(data.notifications || []);
      } else {
        console.error('Failed to fetch notifications');
      }
    } catch (error) {
      console.error('Error fetching notifications:', error);
      toast.error('Failed to fetch notifications');
    } finally {
      setLoading(false);
    }
  };

  const markAsRead = async (notificationId) => {
    try {
      const accessToken = localStorage.getItem(AUTH_TOKEN_KEY);
      
      const response = await fetch(`${API_BASE_URL}api/doctor/notifications/${notificationId}/read`, {
        method: 'PUT',
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
        },
      });

      if (response.ok) {
        setNotifications(prev => 
          prev.map(notif => 
            notif._id === notificationId ? { ...notif, isRead: true } : notif
          )
        );
      }
    } catch (error) {
      console.error('Error marking notification as read:', error);
    }
  };

  const deleteNotification = async (notificationId) => {
    try {
      const accessToken = localStorage.getItem(AUTH_TOKEN_KEY);
      
      const response = await fetch(`${API_BASE_URL}api/doctor/notifications/${notificationId}`, {
        method: 'DELETE',
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
        },
      });

      if (response.ok) {
        setNotifications(prev => prev.filter(notif => notif._id !== notificationId));
        toast.success('Notification deleted');
      }
    } catch (error) {
      console.error('Error deleting notification:', error);
      toast.error('Failed to delete notification');
    }
  };

  if (loading) {
    return <LoadingSpinner message="Loading notifications..." />;
  }

  return (
    <DashboardLayout title="Notifications" showBackButton={true}>

      {notifications.length === 0 ? (
        <div className="empty-state">
          <FaBell className="empty-icon" />
          <h3>No notifications</h3>
          <p>You don't have any notifications at the moment.</p>
        </div>
      ) : (
        <div className="notifications-list">
          {notifications.map((notification) => (
            <div 
              key={notification._id} 
              className={`notification-card ${!notification.isRead ? 'unread' : ''}`}
            >
              <div className="notification-content">
                <h4>{notification.title}</h4>
                <p>{notification.message}</p>
                <span className="notification-time">
                  {new Date(notification.createdAt).toLocaleDateString()}
                </span>
              </div>
              <div className="notification-actions">
                {!notification.isRead && (
                  <button 
                    className="action-btn-notification read-btn"
                    onClick={() => markAsRead(notification._id)}
                  >
                    <FaCheck />
                  </button>
                )}
                <button 
                  className="action-btn-notification delete-btn"
                  onClick={() => deleteNotification(notification._id)}
                >
                  <FaTrash />
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </DashboardLayout>
  );
};

export default NotificationScreen;